import { Component, AfterViewInit } from '@angular/core';
import { Crypto } from 'src/app/service/classes/crypto/crypto';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-beneficio-manutencao',
  template: `
    <div style="text-align:center; padding: 50px 20px;">
      <h3 aria-live="polite">🔗 Conectando ao Sistema de Benefícios...</h3>
      <p>Por favor, aguarde enquanto redirecionamos você.</p>

      <div style="margin-top:24px">
        <p style="margin-bottom:8px">
          Se você <strong>não foi redirecionado</strong>, desative o bloqueio de pop-ups ou clique
          no botão abaixo para tentar novamente.
        </p>

        <button class="btn btn-secondary" (click)="enviarFormulario()" [disabled]="tentando">
          {{ tentando ? 'Tentando…' : 'Tentar novamente' }}
        </button>

        <div *ngIf="erro" style="margin-top:12px; color:#b00020">
          {{ erro }}
        </div>
      </div>
    </div>
  `,
})
export class BeneficioManutencaoComponent implements AfterViewInit {
  tentando = false;
  erro: string | null = null;
  private readonly apiRoot = 'https://api-relatorios-php.elogica.info';
  private readonly basicUser = '3l0g1k4';
  private readonly basicPass = 'dtr5x8!qAa6>';

  constructor(private router: Router, private http: HttpClient) {
    this.verificarAutenticacao();
  }

  ngAfterViewInit(): void {
    this.enviarFormulario();
  }

  private verificarAutenticacao(): void {
    const cred = this.obterCredenciaisLocal();
    if (!cred.LoginSUsuario) {
      this.router.navigate(['/login']);
    }
  }

  private obterCredenciaisLocal(): any {
    try {
      const utilCriptografado = localStorage.getItem('util');
      if (!utilCriptografado) return {};
      const utilDecriptado = new Crypto().decryptUsingAES256(utilCriptografado);
      return JSON.parse(utilDecriptado);
    } catch {
      return {};
    }
  }

  private async obterLoginDaApi(): Promise<string | null> {
    const local = this.obterCredenciaisLocal();
    const codigoUsuario = local?.CodigoUsuario;
    if (!codigoUsuario) return null;

    const url = `${this.apiRoot}/seguranca/${encodeURIComponent(codigoUsuario)}`;
    const headers = {
      Authorization: 'Basic ' + btoa(`${this.basicUser}:${this.basicPass}`)
    };

    try {
      const res: any = await this.http.get(url, { headers }).toPromise();
      return res?.result?.[0]?.login || null;
    } catch (e) {
      this.erro = 'Erro ao obter login do servidor.';
      return null;
    }
  }

  async enviarFormulario(): Promise<void> {
    this.tentando = true;
    this.erro = null;

    const local = this.obterCredenciaisLocal();
    const loginSUsuario = local?.LoginSUsuario;
    if (!loginSUsuario) {
      this.erro = 'LoginSUsuario não encontrado. Faça login novamente.';
      this.tentando = false;
      return;
    }

    const login = await this.obterLoginDaApi();
    if (!login) {
      this.erro = 'Não foi possível obter o login do servidor.';
      this.tentando = false;
      return;
    }

    const credencialBase64 = btoa(`${login}:${loginSUsuario}`);

    try {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = 'https://ptrc-rh.elogica.info/url/login/autenticacao-cruzada.cshtml';
      form.target = '_blank';
      form.innerHTML = `
        <input type="hidden" name="conteudo" value="${credencialBase64}">
        <input type="hidden" name="link" value="beneficio/manutencao.cshtml">
      `;
      document.body.appendChild(form);
      form.submit();
      form.remove();
    } catch {
      this.erro = 'Não foi possível redirecionar. Tente novamente.';
    } finally {
      this.tentando = false;
    }
  }
}
